import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { getEntraLoginHint } from "./loginPreferences";

/**
 * The cached Entra account to resume, or null when the cache cannot identify one unambiguously.
 * Shared by the sign-in flow and api.ts so both resume the same identity. The cache is persistent
 * now and accumulates every account a machine has signed in with, so guessing between them would
 * sign the user in - or send a request - as somebody else.
 */
export function resolveCachedEntraAccount(instance: IPublicClientApplication): AccountInfo | null {
  const activeAccount = instance.getActiveAccount();
  if (activeAccount) {
    return activeAccount;
  }

  const allAccounts = instance.getAllAccounts();
  const rememberedHint = getEntraLoginHint();
  if (rememberedHint) {
    // `filter` rather than `find` because the build targets es5.
    const hintedAccount = allAccounts.filter(
      (candidate) => (candidate.username || "").toLowerCase() === rememberedHint.toLowerCase()
    )[0];
    if (hintedAccount) {
      return hintedAccount;
    }
  }

  // One account is unambiguous; several with nothing to choose by is a guess.
  return allAccounts.length === 1 ? allAccounts[0] : null;
}
